import { useEffect, useState } from "react"
import Card from "../../card/Card"
import renderChildren from "../../utils/renderChildren"
import { useDiscardFormStateContext } from "./DiscardFormStateContext"

// FormStateCard can either be a parent or child of the
// DiscardFormStateContext.Provider. When a parent, it will
// expect the children it renders to update its discardState.
// When a child, it will depend on DiscardFormStateContext.

// The main purpose of FormStateCard is to handle the card's
// "dirty" state and discarding changes when closing the card.
// The card.onClose is only called when the user clicks the Card's
// close button, and naturally the current changes should be discarded.
const FormStateCard = ({ card, children, ...cardProps }) => {
  const [discardState, setDiscardState] = useState({})
  const discardFormStateContext = useDiscardFormStateContext()

  const { discardCount, discardFormState } =
    discardFormStateContext || discardState

  useEffect(() => {
    const isDirty = Boolean(discardCount)
    if (card.isDirting !== isDirty) card.setCardDirty(isDirty)
  }, [discardCount])

  return (
    <Card
      card={{
        ...card,
        onClose: (...args) => {
          if (discardCount && discardFormState) discardFormState()
          card.onClose(...args)
        }
      }}
      {...cardProps}
    >
      {renderChildren({
        children,
        onChangeDiscardFormState: setDiscardState
      })}
    </Card>
  )
}

FormStateCard.displayName = "FormStateCard"

export default FormStateCard
